export const TOOL_CALL_DESCRIPTION_FIELD = "toolCallDescription";

export const AI_CHAT_USER_MESSAGE_TEST_ID = "ai-chat-user-message";
export const AI_CHAT_ASSISTANT_MESSAGE_TEST_ID = "ai-chat-assistant-message";
